
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import { withStyles } from '@material-ui/core/styles';
import { documentStyles } from '../../Styles/documentStyles';
import Images from '../../Theme/Images';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import { ReactSVG } from 'react-svg'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Button from '@material-ui/core/Button';
import Loader from 'react-loader-spinner'
import IdleTimer from 'react-idle-timer';
//import SubmitDialog from './SubmitDialog';
import { Scrollbars } from 'react-custom-scrollbars';

@inject('templateStore', 'dashboardStore')
@observer
class TemplateForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validationErrors: {},
            openSubmitDialog: false,
            currentField: ''
        }
        this._areaElement = new Map();
        this._areaElementBack = new Map();
    }

    handleLabelChange = (value, index, fieldId, type) => {
        // this.props.templateStore.updateLabel(value, index, fieldId, type)
    }

    ntn = () => {

    }

    getFormFields = (item, index) => {
        const { validationErrors } = this.state;
        const { classes, theme } = this.props;
        const { imageFacingSide, currentPage } = this.props.templateStore;
        switch ('text') {
            case 'text':
                return (
                    <ListItem key={index} style={{ paddingTop: 0, marginTop: 0, marginBottom: '2vh' }}>
                        <div className={classes.textContainer} >
                            <TextField
                                coords={item.pts.slice()}
                                ref={c => this._areaElement.set(index, c)}
                                onClick={(e) => this.setCurrentField(e, index, item)}
                                color="primary"
                                style={{ paddingTop: 0, marginTop: 0, marginBottom: '0px', borderBottom: `solid 1px ${theme.palette.battleShipGray}` }}
                                id={item.label}
                                key={item._id}
                                label="Key"
                                type={item.type}
                                margin="normal"
                                variant="filled"
                                fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment:
                                        <InputAdornment position="end">
                                            {currentPage.labelData[index].progressIcon}
                                        </InputAdornment>

                                }}
                                value={item.editedLabel.length != 0 ? item.editedLabel : item.aiLabel}
                                onChange={(event) => this.handleLabelChange(event.target.value, index, item._id, item.editedLabel !== "" ? "editedLabel" : "aiLabel")}
                            />

                            <TextField
                                coords={item.pts.slice()}
                                ref={c => this._areaElement.set(index, c)}
                                onClick={(e) => this.setCurrentField(e, index, item)}
                                color="primary"
                                style={{ paddingTop: 0, marginTop: 0, marginBottom: '0px', }}
                                id={item.label}
                                key={index + 'value'}
                                label="Value"
                                type={item.type}
                                margin="normal"
                                variant="filled"
                                fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment:
                                        <InputAdornment position="end">
                                            {currentPage.labelData[index].progressIcon}
                                        </InputAdornment>

                                }}
                                value={item.editedValue !== "" ? item.editedValue : item.aiValue}
                            />

                            {validationErrors[item.label] && <FormHelperText id={item.label}>{validationErrors[item.label]}</FormHelperText>}

                        </div>
                    </ListItem>
                )
        }
    }


    onSubmit = (finalSubmit, autoSave, next) => {
        const { currentTemplate, currentPage } = this.props.templateStore;
        if (!next && !autoSave) {
            this.props.templateStore.updateTemplate(true, false)
            //  this.setState({ openSubmitDialog: true })
            this.props.history.push(`/template/mapping/${currentTemplate._id}`)

        }
        else
            this.props.templateStore.updateTemplate(finalSubmit, next)
    }

    cancelSubmit = () => {
        this.setState({ openSubmitDialog: false })
    }

    downloadDoc = (doc) => {
        //this.props.templateStore.exportXls(doc._id)
    }

    onCancel = () => {
        this.props.history.push("/dashboard/templates");
    }

    save = () => {
        this.onSubmit(false, true, false);
    }

    setCurrentField = (e, index, item) => {
        this.setState({
            currentField: index
        })
        this.props.templateStore.setCurrentField(item, index)
        this.props.highlight(e, index)
    }

    exportDoc = () => {
        const { currentTemplate } = this.props.templateStore;
        let temp = [];
        temp.push(currentTemplate._id);
        this.props.dashboardStore.exportXls(temp, 'EXPORTED')

    }

    componentWillUnmount() {
        this.props.removeHighlight(undefined, this.props.templateStore.currentIndex)
    }

    changePage = (type) => {
        const { currentPage, currentTemplate } = this.props.templateStore;
        let index = currentTemplate.pageArray.findIndex(x => x._id === currentPage._id);
        this.props.resetImage()
        if (type === '-')
            this.props.templateStore.setCurrentPage(currentTemplate.pageArray[index - 1], index - 1);
        else
            this.props.templateStore.setCurrentPage(currentTemplate.pageArray[index + 1], index + 1);
    }

    finalSubmit = () => {
        // this.props.templateStore.updateTemplate(true, false)
    }


    render() {
        const { classes } = this.props;
        const { currentPage, currentTemplate, inProgress, updateProgress } = this.props.templateStore;
        return (
            <div className={classes.formDiv}>
                <div className={classes.headerContainer}>
                    <div className={classes.docHeader}>{currentTemplate.templateName}
                    </div>
                    {currentTemplate.pageArray[currentTemplate.pageArray.length - 1]._id === currentPage._id && currentPage.reviewed ? <ReactSVG src={Images.exportSingle} onClick={(e) => this.exportDoc()} beforeInjection={svg => { svg.classList.add(classes.svg) }} /> : null}
                </div>
                <IdleTimer ref="saveTimer" onAction={this.save} debounce={1000} timeout={10000} startOnLoad={false} >
                    <form noValidate autoComplete="off" className={classes.formStyle}>
                        <Scrollbars>
                            <List>
                                {
                                    currentPage && currentPage.labelData.map((item, index) => {
                                        return this.getFormFields(item, index)
                                    })
                                }
                            </List>
                        </Scrollbars>
                    </form>
                </IdleTimer>
                <div className={classes.formSubmitContainer}>
                    <div>
                        {
                            currentTemplate.pageArray[currentTemplate.pageArray.length - 1]._id === currentPage._id ?
                                (updateProgress ?
                                    <Button variant="contained" className={classes.submitButton} fullWidth>
                                        <Loader height={30} width={30} color={this.props.theme.palette.white} />
                                    </Button>
                                    : <Button onClick={(event) => this.onSubmit(true, false, false)} variant="contained" style={{ width: '14vw' }} className={classes.submitButton} type="submit" fullWidth>
                                        Proceed to Mapping
                                    </Button>) :
                                <Button onClick={(event) => this.onSubmit(true, false, true)} variant="contained" className={classes.submitButton} type="submit" fullWidth>
                                    Next
                        </Button>

                        }
                        <Button onClick={(event) => this.onCancel()} variant="contained" style={{ backgroundColor: this.props.theme.palette.dark }} className={classes.submitButton} type="submit" fullWidth>
                            Cancel
                        </Button>
                    </div>
                    <div className={classes.pageAction} >
                        {currentTemplate.pageArray.findIndex(x => x._id === currentPage._id) - 1 >= 0 ?
                            <ReactSVG className={classes.navIcons} src={Images.backArrow} onClick={(e) => this.changePage('-')} /> :
                            <ReactSVG className={classes.navIcons} src={Images.backArrowInactive} />
                        }
                        {currentTemplate.pageArray[currentTemplate.pageArray.length - 1]._id === currentPage._id ?
                            <ReactSVG className={classes.navIcons} src={Images.nextArrowInactive} /> :
                            <ReactSVG className={classes.navIcons} src={Images.nextArrow} onClick={(event) => this.changePage('+')} />
                        }
                    </div>
                    {currentTemplate.exportUrl !== undefined ?
                        <Button variant="contained" className={classes.submitButton} type="submit" onClick={(event) => { this.downloadDoc(currentTemplate) }} fullWidth>
                            Download
                        </Button> : null
                    }
                </div>
                {/*                <SubmitDialog open={this.state.openSubmitDialog} cancelSubmit={this.cancelSubmit} submit={this.finalSubmit}></SubmitDialog>
*/}            </div>

        )
    }
}
export default withStyles(documentStyles, { withTheme: true })(withRouter(TemplateForm));
